export const JODIT_CONFIGURATION = {
  buttons: 'fontsize,ul,ol',
  buttonsMD: 'ul,ol,fontsize',
  buttonsSM: 'ul,ol,fontsize',
  buttonsXS: 'ul,ol,fontsize',
  defaultActionOnPaste: 'insert_only_text',
  askBeforePasteHTML: false,
  askBeforePasteFromWord: false,
};
